import { BalancesSummary } from './balances-summary.model';
import { BalancesConstants } from './../../utils/balances/balances-constants';
import { CoreConstants } from '@pershing/pershing-core';
import { ContextEntity } from './context-entity.model';

export class Balances {
    constructor(public contextEntity: ContextEntity, public balancesSummary: BalancesSummary) {}
}

export function defaultBalances(): Balances {
    return {
        contextEntity: {
            entityId: undefined,
            entityName: undefined,
            context: CoreConstants.ACCOUNT,
            contextInfo: {
                accountCategory: BalancesConstants.BROKERAGE_ACCOUNT
            },
            quoteType: undefined
        },
        balancesSummary: {
            totalAccountWorth: {
                value: undefined,
                difference: undefined,
                percentChange: undefined
            },
            fundsAvailableToWithdraw: undefined,
            fundsAvailableToTrade: undefined,
            fundsDue: undefined
        }
    };
}
export function zeroBalances(): Balances {
    return {
        contextEntity: {
            entityId: undefined,
            entityName: undefined,
            context: undefined,
            contextInfo: undefined,
            quoteType: undefined
        },
        balancesSummary: {
            totalAccountWorth: BalancesConstants.zeroDataSet,
            fundsAvailableToWithdraw: BalancesConstants.zeroBalance,
            fundsAvailableToTrade: BalancesConstants.zeroBalance,
            fundsDue: BalancesConstants.zeroBalance
        }
    };
}
